module.exports = __webpack_public_path__ + "static/media/feature_img_1.cf38b4ce.png";